<template>
<v-form  ref="form">
        <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
              <v-layout wrap>
            <v-flex xs12>
            <h3 class="headline">Enter your email to reset the password</h3>
            <span v-if="errorMessage != ''" class="caption error">{{errorMessage}}</span>
            <span v-else-if="successMessage != ''" class="caption success">{{successMessage}}</span>
            </v-flex>
             <v-flex xs12>
            <v-text-field
            label="Email"
            v-model="email"
            required
            :error-messages="emailErrors"
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
             ></v-text-field>
             </v-flex>
        </v-layout>
          </v-card-title>
          <v-card-actions>
            <v-btn color="primary" flat @click="submit" >Send me a recovery link</v-btn>
            <v-btn color="primary" flat @click.stop="$emit('clicked')">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  props: ["dialog"],
  validations: {
     email: { required, email },
  },
  data() {
    return {
      email: "",
      errorMessage:"",
      successMessage:""
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.recover();
    },
recover() {
   this.$store.dispatch('recoverPass',{email:this.email}).then((response) => {
       console.log(response.data.error)
       if(response.data.error)
       {
       this.successMessage="";
       this.errorMessage = response.data.error;
       }
       else if(response.data.success)
       {
       this.errorMessage = "";
       this.successMessage = response.data.success;   
       }
   }).catch((err) => {
       console.log(err);
   })
}
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/Dialog.vue